var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"property-map"},[_c('div',{ref:"mapEl",staticClass:"property-map__map"}),_c('item-breadcrumb',{attrs:{"property":_vm.property,"site":_vm.site}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }